import type { CalloutBlock, SlateLeaf } from '@atlas/renderer';

export default function createCalloutBlock(children?: SlateLeaf[], icon?: string): CalloutBlock {
    return {
        type: 'callout',
        children: [
            { type: 'icon', children: [{ text: '' }], icon: icon || defaultCalloutIcon },
            { type: 'paragraph', children: children || [] },
        ],
    };
}

// #region Helpers

export const defaultCalloutIcon = '💡';

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('createCalloutBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
